import React from 'react';

const MIN_WIDTH = 60;

// Drop-in replacement for a plain <th> that adds an Excel-style drag handle
// on its right edge. Pair with useColumnWidths(storageKey) for persistence:
//   const { widths, setWidth } = useColumnWidths('product-master');
//   <ResizableTh column="product_code" defaultWidth={140} widths={widths} onResize={setWidth}>
//     Product Code
//   </ResizableTh>
export default function ResizableTh({ column, defaultWidth, widths, onResize, children, style, ...rest }) {
  const width = widths?.[column] ?? defaultWidth;

  const handleMouseDown = (e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = width;
    const onMove = (ev) => onResize(column, Math.max(MIN_WIDTH, startWidth + ev.clientX - startX));
    const onUp = () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
    };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  };

  return (
    <th {...rest} style={{ ...style, width, position: 'relative' }}>
      {children}
      <span
        className="col-resize-handle"
        onMouseDown={handleMouseDown}
        onClick={(e) => e.stopPropagation()}
      />
    </th>
  );
}
